import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import "./AccessibilityStatement.css";

const AccessibilityStatement: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // קביעת כיוון הטקסט לפי השפה
  const direction = i18n.language === "he" ? "rtl" : "ltr";

  // גלילה אוטומטית לתחילת הדף כשמגיעים אליו
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div
      className="accessibility-statement-page"
      dir={direction}
      data-language={i18n.language}
      lang={i18n.language === "he" ? "he" : "ru"}
    >
      <div className="accessibility-statement-container">
        <h1 className="accessibility-statement-title">
          {t("accessibilityStatementTitle")}
        </h1>

        <div className="accessibility-statement-content">
          <section className="accessibility-section">
            <h2>{t("accessibilityStatementIntro")}</h2>
            <p>{t("accessibilityStatementIntroText")}</p>
          </section>

          <section className="accessibility-section">
            <h2>{t("accessibilityStandardTitle")}</h2>
            <p>{t("accessibilityStandardText")}</p>
          </section>

          <section className="accessibility-section-list">
            <h2>{t("accessibilityFeaturesTitle")}</h2>
            <ul className="accessibility-list">
              <li>{t("accessibilityFeaturesList1")}</li>
              <li>{t("accessibilityFeaturesList2")}</li>
              <li>{t("accessibilityFeaturesList3")}</li>
              <li>{t("accessibilityFeaturesList4")}</li>
              <li>{t("accessibilityFeaturesList5")}</li>
              <li>{t("accessibilityFeaturesList6")}</li>
              <li>{t("accessibilityFeaturesList7")}</li>
              <li>{t("accessibilityFeaturesList8")}</li>
              <li>{t("accessibilityFeaturesList9")}</li>
              <li>{t("accessibilityFeaturesList10")}</li>
              <li>{t("accessibilityFeaturesList11")}</li>
              <li>{t("accessibilityFeaturesList12")}</li>
            </ul>
          </section>

          <section className="accessibility-section">
            <h2>{t("accessibilityContactTitle")}</h2>
            <p>{t("accessibilityContactText")}</p>
            <div className="accessibility-contact-details">
              <p>
                <strong>{t("accessibilityContactName")}</strong>
              </p>
              <p>
                <strong>{t("accessibilityContactEmail")}</strong>
              </p>
              <p>
                <strong>{t("accessibilityContactPhone")}</strong>
              </p>
              <p className="accessibility-contact-note">
                {t("accessibilityContactNote")}
              </p>
            </div>
          </section>

          <section className="accessibility-section">
            <h2>{t("accessibilityImprovementsTitle")}</h2>
            <p>{t("accessibilityImprovementsText")}</p>
          </section>

          <section className="accessibility-section">
            <p className="accessibility-last-update">
              {/* <em>{t('accessibilityLastUpdate')}</em> */}
            </p>
          </section>
        </div>

        <div className="custom-button">
          <button onClick={handleGoBack} className="custom-button">
            {t("backToPreviousPage")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityStatement;
